<template>
    <NumberInputWithButtons
        v-model="discountForEdit.amount"
        :label="
            discountForEdit.discountConditions.unitOfMeasurement === 'PERCENT'
                ? `${$t('percent')}*`
                : `${$t('amount')}*`
        "
        :width="200"
        :buttons="[
            {
                icon: 'mdi-percent',
                active: discountForEdit.discountConditions.unitOfMeasurement === 'PERCENT',
                onClick: () => (discountForEdit.discountConditions.unitOfMeasurement = 'PERCENT'),
            },
            {
                icon: 'mdi-cash',
                active: discountForEdit.discountConditions.unitOfMeasurement === 'FIXED_VALUE',
                onClick: () => (discountForEdit.discountConditions.unitOfMeasurement = 'FIXED_VALUE'),
            },
        ]"
        :rules="[requiredRule('')]"
    />
</template>

<script setup lang="ts">
    const discountForEdit = defineModel<any>()
</script>
